import { PrimaryButton } from "components/Buttons/PrimaryButton";
import { ModalCard } from "components/Modal";
import React, { useState } from "react";
import { buyAnExam } from "./firebase";
import CloseIcon from "mdi-react/CloseIcon";
import Row from "components/Row";

export default function PayModal(props) {
  const [loading, setLoading] = useState(false);

  async function payForExam() {
    setLoading(true);
    // TODO: Get exam detail, key and name probably.
    var response = await buyAnExam(1, "Payment for an Exam.");
    if (response.success) {
      // TODO: SHow Payment has been made
      props.onSuccess();
    } else {
      alert(response.message);
    }
    setLoading(false);
  }

  return (
    <React.Fragment>
      <ModalCard>
        <Row justify="space-between">
          <div
            style={{
              fontSize: "2em",
              fontWeight: "bold",
              marginBottom: "20px"
            }}
          >
            Buy Exam
          </div>
          <CloseIcon style={{ cursor: "pointer" }} onClick={props.onClick} />
        </Row>
        <div>Are you sure you want to continue?</div>
        <PrimaryButton
          onClick={async () => {
            payForExam();
          }}
          loading={loading}
          small
          style={{ marginTop: "20px" }}
        >
          Pay Now ( 1 Point )
        </PrimaryButton>
      </ModalCard>
    </React.Fragment>
  );
}
